import github from "images/github.svg";
import linkedin from "images/linkedin.svg";
import whatsapp from "images/whatsapp.svg";

export const SITES = [
  {
    icon: linkedin,
    name: "LinkedIn",
    url: "https://www.linkedin.com/in/pedrotortello/",
  },
  {
    icon: github,
    name: "GitHub",
    url: "https://github.com/ptortello/",
  },
  {
    icon: whatsapp,
    name: "WhatsApp",
    url: "https://api.whatsapp.com/send?phone=5515991049183/",
  },
];
